export default "/images/logo_front.svg?2103afde0dd876042e78b97c1cf86c55";